import { render, staticRenderFns } from "./chatgpt.vue?vue&type=template&id=691bc1b2&scoped=true"
import script from "./chatgpt-script.js?vue&type=script&lang=js&external"
export * from "./chatgpt-script.js?vue&type=script&lang=js&external"
import style0 from "./chatgpt.vue?vue&type=style&index=0&id=691bc1b2&prod&lang=scss"
import style1 from "./chatgpt.vue?vue&type=style&index=1&id=691bc1b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691bc1b2",
  null
  
)

export default component.exports